import type { ReactElement } from "react";
import { Field } from "@cx/ui";
import type { ServiceForm } from "./labels";

/** Serviço prestado da NFS-e: código de tributação nacional, municipal, CNAE, NBS e discriminação. */
export function ServiceFields({
  value,
  onChange,
  errors,
  prefix = "service",
  disabled,
}: {
  value: ServiceForm;
  onChange(v: ServiceForm): void;
  errors: Record<string, string>;
  prefix?: string;
  disabled?: boolean;
}): ReactElement {
  const set = <K extends keyof ServiceForm>(k: K, v: ServiceForm[K]) => onChange({ ...value, [k]: v });
  return (
    <div className="row">
      <Field
        label="Código de tributação nacional"
        required
        className="col-md-4"
        error={errors[`${prefix}.cTribNac`]}
        hint="Item, subitem e desdobro da LC 116 (ex.: 01.07.01)"
      >
        <input
          value={value.cTribNac}
          maxLength={10}
          disabled={disabled}
          onChange={(e) => set("cTribNac", e.target.value)}
        />
      </Field>
      <Field label="Código municipal" className="col-md-3" error={errors[`${prefix}.cTribMun`]}>
        <input
          value={value.cTribMun}
          maxLength={20}
          disabled={disabled}
          onChange={(e) => set("cTribMun", e.target.value)}
        />
      </Field>
      <Field label="CNAE" className="col-md-2" error={errors[`${prefix}.cnae`]}>
        <input
          inputMode="numeric"
          value={value.cnae}
          maxLength={9}
          disabled={disabled}
          onChange={(e) => set("cnae", e.target.value)}
        />
      </Field>
      <Field label="NBS" className="col-md-3" error={errors[`${prefix}.nbs`]}>
        <input
          inputMode="numeric"
          value={value.nbs}
          maxLength={12}
          disabled={disabled}
          onChange={(e) => set("nbs", e.target.value)}
        />
      </Field>
      <Field
        label="Discriminação do serviço"
        required
        className="col-12"
        error={errors[`${prefix}.description`]}
      >
        <textarea
          rows={3}
          value={value.description}
          maxLength={2000}
          disabled={disabled}
          onChange={(e) => set("description", e.target.value)}
        />
      </Field>
    </div>
  );
}
